"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    textareaClassNames: function() {
        return textareaClassNames;
    },
    useTextareaStyles_unstable: function() {
        return useTextareaStyles_unstable;
    }
});
const _react = require("@griffel/react");
const textareaClassNames = {
    root: 'fui-Textarea',
    textarea: 'fui-Textarea__textarea'
};
/**
 * Styles for the root(wrapper) slot
 */ const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        mc9l5x: "ftuwxu6",
        B7ck84d: "f1ewtqcl",
        qhf8xq: "f10pi13n",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1ean75l",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "f11qmguv",
            "f1tyq0we"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f1tyq0we",
            "f11qmguv"
        ],
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ]
    },
    disabled: {
        De3pzq: "f1c21dwh",
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        Bjwas2f: "fg455y9",
        Bn1d65q: [
            "f1rvyvqg",
            "f14g86mu"
        ],
        Bxeuatn: "f1cwzwz",
        n51gp8: [
            "f14g86mu",
            "f1rvyvqg"
        ]
    },
    interactive: {
        li1rpt: "f1gw3sf2",
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9",
        Eqx8gd: [
            "f1a7op3",
            "f1cjjd47"
        ],
        By385i5: "f1gboi2j",
        B1piin3: [
            "f1cjjd47",
            "f1a7op3"
        ],
        Dlnsje: "ffyw7fx",
        d9w3h3: [
            "f1kp91vd",
            "f1ibwz09"
        ],
        B3778ie: [
            "f1ibwz09",
            "f1kp91vd"
        ],
        Bcgy8vk: "f14pi962",
        Bw17bha: "f1lh990p",
        B1q35kw: "f1jc6hxc",
        Gjdm7m: "fj2g8qd",
        b1kco5: "f1yk9hq",
        Ba2ppi3: "fhwpy7i",
        F2fol1: "f14ee0xe",
        lck23g: "f1xhbsuh",
        df92cz: "fv8e3ye",
        I188md: "ftb5wc6",
        umuwi5: "fjw5xc1",
        Blcqepd: "f1xdyd5c",
        nplu4u: "fatpbeo",
        Bioka5o: "fb7uyps",
        H713fs: "f1cmft4k",
        B9ooomg: "f1x58t8o",
        Bercvud: "f1ibeo51",
        Bbr2w1p: "f1vnc8sk",
        Bduesf4: "f3e99gv",
        Bpq79vn: "fhljsf7"
    },
    filled: {
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        q7v0qe: "ftmjh5b",
        kmh5ft: [
            "f17blpuu",
            "fsrcdbj"
        ],
        nagaa4: "f1tpwn32",
        B1yhkcb: [
            "fsrcdbj",
            "f17blpuu"
        ]
    },
    "filled-darker": {
        De3pzq: "f16xq7d1"
    },
    "filled-lighter": {
        De3pzq: "fxugw4r"
    },
    "filled-darker-shadow": {
        De3pzq: "f16xq7d1",
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "f1bh3yvw",
        h3c5rm: [
            "fmi79ni",
            "f11fozsx"
        ],
        B9xav0g: "fnzw4c6",
        zhjwy3: [
            "f11fozsx",
            "fmi79ni"
        ],
        E5pizo: "fyed02w"
    },
    "filled-lighter-shadow": {
        De3pzq: "fxugw4r",
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "f1bh3yvw",
        h3c5rm: [
            "fmi79ni",
            "f11fozsx"
        ],
        B9xav0g: "fnzw4c6",
        zhjwy3: [
            "f11fozsx",
            "fmi79ni"
        ],
        E5pizo: "fyed02w"
    },
    outline: {
        De3pzq: "fxugw4r",
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1c1zstj",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ]
    },
    outlineInteractive: {
        ckks6v: "f7ic3uo",
        B2zwrfe: [
            "f1omjgsz",
            "f1snvl17"
        ],
        xv9156: "fn6xmsl",
        dt87k2: [
            "f1snvl17",
            "f1omjgsz"
        ],
        Bf40cpq: "f1sn8sm0",
        Bop6t4b: [
            "f1wovo5e",
            "f716mnf"
        ],
        gvrnp0: "fm0h710",
        Beu9t3s: [
            "f716mnf",
            "f1wovo5e"
        ],
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "f1l4zc64",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        uqwnxt: "fk7lb2a",
        Bvecx4l: [
            "f1knhbbd",
            "f17itt0b"
        ],
        Bs0cc2w: "f15pjvi3",
        e1hlit: [
            "f17itt0b",
            "f1knhbbd"
        ],
        e2sjt0: "f6ginmj",
        Bbcopvn: [
            "f1grcyuh",
            "fgzu20w"
        ],
        Bj33j0h: "fk1xjsr",
        f7epvg: [
            "fgzu20w",
            "f1grcyuh"
        ],
        B6oc9vd: "fvs00aa",
        ak43y8: [
            "f1assf6x",
            "f4ruux4"
        ],
        wmxk5l: "f1z0osm6",
        B50zh58: [
            "f4ruux4",
            "f1assf6x"
        ],
        Bbs6y8j: "fu7v4fk",
        rexu52: [
            "f1fnaxjy",
            "fwory1w"
        ],
        B7pmvfx: "f7hodha",
        Belqbek: [
            "fwory1w",
            "f1fnaxjy"
        ],
        Bawrxx6: "f8jkv7v",
        r7b1zc: [
            "f1f3jaeo",
            "fh8au0q"
        ],
        Bt3ojkv: "f19usxel",
        t1ykpo: [
            "fh8au0q",
            "f1f3jaeo"
        ],
        Bvq3b66: "f12oevn0",
        Brahy3i: [
            "fvdgz8d",
            "f1cq0lt5"
        ],
        zoxjo1: "f1so894s",
        an54nd: [
            "f1cq0lt5",
            "fvdgz8d"
        ]
    },
    invalid: {
        tvckwq: "fs4k3qj",
        gk2u95: [
            "fcee079",
            "fmyw78r"
        ],
        hhx65j: "f1fgmyf4",
        Bxowmz0: [
            "fmyw78r",
            "fcee079"
        ]
    }
}, {
    d: [
        ".ftuwxu6{display:inline-flex;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f10pi13n{position:relative;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1ean75l{padding-bottom:var(--strokeWidthThick);}",
        ".f1hu3pq6{margin-top:0;}",
        ".f11qmguv{margin-right:0;}",
        ".f1tyq0we{margin-left:0;}",
        ".f19f4twv{margin-bottom:0;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gw3sf2::after{box-sizing:border-box;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f1a7op3::after{left:-1px;}",
        ".f1cjjd47::after{right:-1px;}",
        ".f1gboi2j::after{bottom:-1px;}",
        ".ffyw7fx::after{height:max(var(--strokeWidthThick), var(--borderRadiusMedium));}",
        ".f1kp91vd::after{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1ibwz09::after{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f14pi962::after{border-bottom-width:var(--strokeWidthThick);}",
        ".f1lh990p::after{border-bottom-style:solid;}",
        ".f1jc6hxc::after{border-bottom-color:var(--colorCompoundBrandStroke);}",
        ".fj2g8qd::after{clip-path:inset(calc(100% - var(--strokeWidthThick)) 0 0 0);}",
        ".f1yk9hq::after{transform:scaleX(0);}",
        ".fhwpy7i::after{transition-property:transform;}",
        ".f14ee0xe::after{transition-duration:var(--durationUltraFast);}",
        ".f1xhbsuh::after{transition-delay:var(--curveAccelerateMid);}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1bh3yvw{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".fmi79ni{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".f11fozsx{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".fnzw4c6{border-bottom-color:var(--colorTransparentStrokeInteractive);}",
        ".fyed02w{box-shadow:var(--shadow2);}",
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        ".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}",
        ".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}",
        ".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}",
        ".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.fv8e3ye::after{transition-duration:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.ftb5wc6::after{transition-delay:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1cmft4k:focus-within::after{transition-duration:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1x58t8o:focus-within::after{transition-delay:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ],
    w: [
        ".fjw5xc1:focus-within::after{transform:scaleX(1);}",
        ".f1xdyd5c:focus-within::after{transition-property:transform;}",
        ".fatpbeo:focus-within::after{transition-duration:var(--durationNormal);}",
        ".fb7uyps:focus-within::after{transition-delay:var(--curveDecelerateMid);}",
        ".f1ibeo51:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".f1vnc8sk:focus-within{outline-width:var(--strokeWidthThick);}",
        ".f3e99gv:focus-within{outline-style:solid;}",
        ".fhljsf7:focus-within{outline-color:transparent;}",
        ".fu7v4fk:focus-within{border-top-width:var(--strokeWidthThin);}",
        ".f1fnaxjy:focus-within{border-right-width:var(--strokeWidthThin);}",
        ".fwory1w:focus-within{border-left-width:var(--strokeWidthThin);}",
        ".f7hodha:focus-within{border-bottom-width:var(--strokeWidthThin);}",
        ".f8jkv7v:focus-within{border-top-style:solid;}",
        ".f1f3jaeo:focus-within{border-right-style:solid;}",
        ".fh8au0q:focus-within{border-left-style:solid;}",
        ".f19usxel:focus-within{border-bottom-style:solid;}",
        ".f12oevn0:focus-within{border-top-color:var(--colorNeutralStroke1);}",
        ".fvdgz8d:focus-within{border-right-color:var(--colorNeutralStroke1);}",
        ".f1cq0lt5:focus-within{border-left-color:var(--colorNeutralStroke1);}",
        ".f1so894s:focus-within{border-bottom-color:var(--colorCompoundBrandStroke);}"
    ],
    h: [
        ".ftmjh5b:hover,.ftmjh5b:focus-within{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".f17blpuu:hover,.f17blpuu:focus-within{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".fsrcdbj:hover,.fsrcdbj:focus-within{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".f1tpwn32:hover,.f1tpwn32:focus-within{border-bottom-color:var(--colorTransparentStrokeInteractive);}",
        ".f7ic3uo:hover{border-top-width:var(--strokeWidthThin);}",
        ".f1omjgsz:hover{border-right-width:var(--strokeWidthThin);}",
        ".f1snvl17:hover{border-left-width:var(--strokeWidthThin);}",
        ".fn6xmsl:hover{border-bottom-width:var(--strokeWidthThin);}",
        ".f1sn8sm0:hover{border-top-style:solid;}",
        ".f1wovo5e:hover{border-right-style:solid;}",
        ".f716mnf:hover{border-left-style:solid;}",
        ".fm0h710:hover{border-bottom-style:solid;}",
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".f1l4zc64:hover{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}"
    ],
    a: [
        ".fk7lb2a:active{border-top-width:var(--strokeWidthThin);}",
        ".f1knhbbd:active{border-right-width:var(--strokeWidthThin);}",
        ".f17itt0b:active{border-left-width:var(--strokeWidthThin);}",
        ".f15pjvi3:active{border-bottom-width:var(--strokeWidthThin);}",
        ".f6ginmj:active{border-top-style:solid;}",
        ".f1grcyuh:active{border-right-style:solid;}",
        ".fgzu20w:active{border-left-style:solid;}",
        ".fk1xjsr:active{border-bottom-style:solid;}",
        ".fvs00aa:active{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1assf6x:active{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f4ruux4:active{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1z0osm6:active{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"
    ]
});
/**
 * Styles for the textarea slot
 */ const useTextareaStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        oivjwe: "f1h8hb77",
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ],
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "f11qmguv",
            "f1tyq0we"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f1tyq0we",
            "f11qmguv"
        ],
        De3pzq: "f3rmtva",
        B7ck84d: "f1ewtqcl",
        sj55zd: "f19n0e5",
        Bh6795r: "fqerorx",
        Bahqtrf: "fk6fouc",
        Bqenvij: "f1l02sjl",
        yvdlaj: "fwyc1cq",
        B3o7kgh: "f13ta7ih",
        B4brmom: "f1vw9udw",
        Brrnbx2: "fbb3kq8",
        oeaueh: "f1s6fcnf"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        yvdlaj: "fahhnxm"
    },
    small: {
        sshi5w: "f1w5jphr",
        z8tnut: "f1ywm7hm",
        z189sj: [
            "fqznh8f",
            "f1xile11"
        ],
        Byoj8tv: "f14wxoun",
        uwmqm3: [
            "f1xile11",
            "fqznh8f"
        ],
        Bxyxcbc: "f192z54u",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    medium: {
        sshi5w: "fvmd9f",
        z8tnut: "fp2oml8",
        z189sj: [
            "f135dnwl",
            "f1e60jzv"
        ],
        Byoj8tv: "f1tdddsa",
        uwmqm3: [
            "f1e60jzv",
            "f135dnwl"
        ],
        Bxyxcbc: "f1if7ixc",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        sshi5w: "f1kfson",
        z8tnut: "f1kwiid1",
        z189sj: [
            "fcgl2c4",
            "f1anj20m"
        ],
        Byoj8tv: "f5b47ha",
        uwmqm3: [
            "f1anj20m",
            "fcgl2c4"
        ],
        Bxyxcbc: "f3kip1f",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1h8hb77{border-bottom-style:none;}",
        ".f1hu3pq6{margin-top:0;}",
        ".f11qmguv{margin-right:0;}",
        ".f1tyq0we{margin-left:0;}",
        ".f19f4twv{margin-bottom:0;}",
        ".f3rmtva{background-color:transparent;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fqerorx{flex-grow:1;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1l02sjl{height:100%;}",
        ".fwyc1cq::-webkit-input-placeholder{color:var(--colorNeutralForeground4);}",
        ".fwyc1cq::-moz-placeholder{color:var(--colorNeutralForeground4);}",
        ".f13ta7ih::-webkit-input-placeholder{opacity:1;}",
        ".f13ta7ih::-moz-placeholder{opacity:1;}",
        ".f1vw9udw::selection{color:var(--colorNeutralForegroundInverted);}",
        ".fbb3kq8::selection{background-color:var(--colorNeutralBackgroundInverted);}",
        ".f1s6fcnf{outline-style:none;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}",
        ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}",
        ".f1w5jphr{min-height:40px;}",
        ".f1ywm7hm{padding-top:var(--spacingVerticalXS);}",
        ".fqznh8f{padding-right:calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}",
        ".f1xile11{padding-left:calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}",
        ".f14wxoun{padding-bottom:var(--spacingVerticalXS);}",
        ".f192z54u{max-height:200px;}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fvmd9f{min-height:52px;}",
        ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}",
        ".f135dnwl{padding-right:calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS));}",
        ".f1e60jzv{padding-left:calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS));}",
        ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}",
        ".f1if7ixc{max-height:260px;}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f1kfson{min-height:64px;}",
        ".f1kwiid1{padding-top:var(--spacingVerticalS);}",
        ".fcgl2c4{padding-right:calc(var(--spacingHorizontalM) + var(--spacingHorizontalXXS));}",
        ".f1anj20m{padding-left:calc(var(--spacingHorizontalM) + var(--spacingHorizontalXXS));}",
        ".f5b47ha{padding-bottom:var(--spacingVerticalS);}",
        ".f3kip1f{max-height:320px;}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
});
/**
 * Styles for the textarea's resize property
 */ const useTextareaResizeStyles = /*#__PURE__*/ (0, _react.__styles)({
    none: {
        B3rzk8w: "f1o1s39h"
    },
    both: {
        B3rzk8w: "f1pxm0xe"
    },
    horizontal: {
        B3rzk8w: "fq6nmtn"
    },
    vertical: {
        B3rzk8w: "f1f5ktr4"
    }
}, {
    d: [
        ".f1o1s39h{resize:none;}",
        ".f1pxm0xe{resize:both;}",
        ".fq6nmtn{resize:horizontal;}",
        ".f1f5ktr4{resize:vertical;}"
    ]
});
const useTextareaStyles_unstable = (state)=>{
    const { size, appearance, resize } = state;
    const disabled = state.textarea.disabled;
    const invalid = `${state.textarea['aria-invalid']}` === 'true';
    const filled = appearance.startsWith('filled');
    const rootStyles = useRootStyles();
    state.root.className = (0, _react.mergeClasses)(textareaClassNames.root, rootStyles.base, disabled && rootStyles.disabled, !disabled && filled && rootStyles.filled, !disabled && rootStyles[appearance], !disabled && rootStyles.interactive, !disabled && appearance === 'outline' && rootStyles.outlineInteractive, !disabled && invalid && rootStyles.invalid, state.root.className);
    const textareaStyles = useTextareaStyles();
    const textareaResizeStyles = useTextareaResizeStyles();
    state.textarea.className = (0, _react.mergeClasses)(textareaClassNames.textarea, textareaStyles.base, textareaStyles[size], textareaResizeStyles[resize], disabled && textareaStyles.disabled, state.textarea.className);
    return state;
}; //# sourceMappingURL=useTextareaStyles.styles.js.map
